// extracted by mini-css-extract-plugin
module.exports = {"content-nav-wrapper":"organization-detail_content-nav-wrapper__11g7t"};